import { useEffect } from 'react';

// Shared broadcaster for the `tradapp:import-complete` CustomEvent. The
// broker import wizard fires this when an upload finishes; position-level
// actions (rollback/delete/reconcile) that mutate journal data reuse the same
// event so the dashboard's existing refresh plumbing picks up the change
// without needing its own listener.
export function broadcastImportComplete(detail = {}) {
  if (typeof window === 'undefined') return;
  try {
    window.dispatchEvent(new CustomEvent('tradapp:import-complete', { detail }));
  } catch (err) {
    if (import.meta.env?.DEV) console.warn('Failed to broadcast import-complete', err);
  }
}

// Subscribes to the global `tradapp:import-complete` CustomEvent fired by
// the broker import wizard when an upload finishes (or times out into the
// background). Pages call this to refetch their data so the dashboards
// reflect the freshly-imported trades without requiring a full reload.
export default function useImportCompleteListener(handler) {
  useEffect(() => {
    if (typeof window === 'undefined') return undefined;
    if (typeof handler !== 'function') return undefined;
    const listener = (event) => {
      try {
        handler(event?.detail || {});
      } catch (err) {
        if (import.meta.env?.DEV) {
          console.warn('useImportCompleteListener handler threw', err);
        }
      }
    };
    window.addEventListener('tradapp:import-complete', listener);
    return () => window.removeEventListener('tradapp:import-complete', listener);
  }, [handler]);
}
